/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { SliceName } from '../constants';

/**
 *@Description: 用于记录layout布局数据的state,方便未来拓展布局多组件使用
*/
export const layoutSettingSlice = createSlice({
  name: SliceName.LayoutSetting,
  initialState: {
    loginLayout: {
      urlShopName: '', // 链接店铺名
      isVisible: false, // 控制登录布局是否显示
      type: 'shopify', // 区分平台shopify等
    },
  },
  reducers: {
    // 用于设置 loginLayout的状态
    setLoginLayout(state, { payload }) {
      if (payload) {
        state.loginLayout = payload;
      }
    },
  },
});

export const {
  setLoginLayout,
} = layoutSettingSlice.actions;

export default layoutSettingSlice.reducer;
